module.exports = __webpack_public_path__ + "static/03-533d02e37a1e9cc4d19f838d929ac3a3.jpg";